module.exports = __webpack_public_path__ + "img/Structures-1.a487a3f7.png";